export const SITE_OPERATOR = 'IdeaHub Digital';
export const SITE_OWNER = 'Sheetal Gulati';
export const SITE_DOMAIN = 'ideahubdigital.com';
export const SITE_CONTACT_EMAIL = 'hello@ideahubdigital.com';
export const SITE_COPYRIGHT = '© 2026 IdeaHub Digital';
